import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import _ from 'lodash';

export default function dashboardGAContextReducer(state = initialstate.dashboardContext, action) {
	switch (action.type) {
		case types.SET_GA_COMPONENT_TREE:
			if (action.data) {
				return !_.isEmpty(action.data) ? action.data : state;
			}
			break;
		case types.CLEAR_GA_COMPONENT_TREE:
			return [];
		case types.SET_ENTITY_CHECKED: {
			let newTree = [...state];
			let entities = [];
			if (action.isScope) {
				for (let e of action.data) {
					let indexOfe = newTree.findIndex((m) => m.gaComponentID == e);
					let entityToMutate = {...newTree.find((m) => m.gaComponentID == e)};
					if (_.size(entityToMutate) > 0) {
						entityToMutate.checked = action.checked;
					}
					newTree[indexOfe] = entityToMutate;
				}
			} else {
				for (let e of action.data) {
					let indexOfe = newTree.findIndex((m) => m.gaComponentID == e);
					let entityToMutate = {...newTree.find((m) => m.gaComponentID == e)};
					if (_.size(entityToMutate) > 0) {
						entityToMutate.checked = action.checked;
					}
					newTree[indexOfe] = entityToMutate;
				}
			}
			return [...newTree];
		}
		case types.SET_WHOLE_ENTITY_CHECKED: {
			let newTree = _.cloneDeep(state);
			newTree.map((entity) => {
				if (action.data.includes(entity.gaComponentID)) {
					entity.checked = true;
				} else {
					entity.checked = false;
				}
			});
			return [...newTree];
		}

		default:
			return state;
	}
}
